import format from "date-fns/format";

import { getOffsetDate } from "fe-shared/src/helpers/dates";

import { NoteRecord } from "../types";

export const formatTransactionNumber = (transactionNumber = "", prefix = "#") =>
  `${prefix}${[
    transactionNumber.slice(0, 3),
    transactionNumber.slice(3, 6),
    transactionNumber.slice(6),
  ]
    .filter(Boolean)
    .join(" ")}`;

export const formatInvoiceNumber = (invoiceNumber = "", prefix = "#") => {
  if (invoiceNumber.length === 10) {
    // old format
    return formatTransactionNumber(invoiceNumber, prefix);
  }

  return `${prefix}${[
    invoiceNumber.slice(0, 1),
    invoiceNumber.slice(1, 3),
    invoiceNumber.slice(3),
  ]
    .filter(Boolean)
    .join(" ")}`;
};

export const formatSum = (sum: number) => {
  return new Intl.NumberFormat("en-CA").format(sum);
};

export const formatDate = (dateString?: string) => {
  if (!dateString) {
    return "";
  }
  const time = dateString?.substr(11, 8);
  const isNoOffset = time === "00:00:00";

  const date = isNoOffset
    ? getOffsetDate(new Date(dateString))!
    : new Date(dateString);

  return format(date, "MMM d, yyyy");
};

export const formatRecord = (record: NoteRecord) =>
  `- ${record.initiator}, ${format(
    new Date(record.createdDate),
    "MMM d, ‘yy, h:mm a"
  )}, ${record.message};`;

export default formatTransactionNumber;
